import { selectAll } from 'css-select';
import { render } from 'dom-serializer';
import { Element, isTag } from 'domhandler';
import type { Node } from 'domhandler';
import { replaceElement } from 'domutils';
import { parseDocument } from 'htmlparser2';

// Legacy petition descriptions saved before the unwrap-side fix have bare
// `<change-media>` siblings sitting between paragraphs (no `<p>` parent).
// Wrap them here so the decoded `<img>` / `<iframe>` inherits the description's
// paragraph spacing (`p + p { margin-top }`) just like content saved by the
// current pipeline. Idempotent — leaves already-wrapped media untouched.
export function wrapBareChangeMediaInParagraphs(html: string): string {
	if (!html.includes('<change-media')) return html;
	const document = parseDocument(html);
	const mediaElements = selectAll<Node, Element>('change-media', document);
	mediaElements.forEach((mediaElement) => {
		const { parent } = mediaElement;
		if (parent && isTag(parent) && parent.tagName === 'p') return;
		const paragraphWrapper = new Element('p', {}, [mediaElement]);
		// replaceElement reads mediaElement.parent — call it before rewiring
		// mediaElement's links to live inside paragraphWrapper.
		replaceElement(mediaElement, paragraphWrapper);
		/* eslint-disable no-param-reassign */
		mediaElement.parent = paragraphWrapper;
		mediaElement.prev = null;
		mediaElement.next = null;
		/* eslint-enable no-param-reassign */
	});
	return render(document);
}
